import React from "react";
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { DialogEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { TimeReportingFormTypes } from "models/formTypes";
//#endregion
//#region components
import CreateDeviationTypeFormContainer from "./createTypeFormContainer";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useCreateDeviationTypeDialog() {
  return (onSubmitSuccess: (data: TimeReportingFormTypes.CreateDeviationType) => void): DialogProps => ({
    isOpen: false,
    title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SalaryDeviation.CreateDeviationTypeHeader),
    subTitle: LocalizationHelperInstance.getFormattedMessage(
      TranslationKeys.SalaryDeviation.CreateDeviationTypeSubHeader
    ),
    titleIcon: IconDefinitionConstants.WDocument,
    dialogType: DialogEnums.DialogType.Content,
    actions: [
      {
        text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.SaveChanges),
        successMessage: TranslationKeys.SalaryDeviation.DeviationTypeSavedSuccessMessage,
      },
    ],
    children: <CreateDeviationTypeFormContainer />,
    onSubmit: onSubmitSuccess,
    maxWidth: "sm",
  });
}

export default useCreateDeviationTypeDialog;
